/* 
 	* 指令下发组件 
 	* 描述：InsGT740GSMOpenSet指令下发
 	* 创建时间：2017-07-27 
 	* 创建人：baixx 
*/
<template>
	<div>
		<form class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-3 control-label">上传间隔</label>
			    <div class="col-sm-6">
			        <input type="text" class="form-control" v-model="uploadInterval"/>
			        <span class="dis_block pt5px orange_t" >单位为秒，有效范围10~1800</span>
			    </div>
			    
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label">持续时间</label>
			    <div class="col-sm-6">
			        <input type="text" class="form-control col-sm-1 timeD" v-model="timeD1"> 
			        <span class="dis_block pt5px orange_t" >单位为分钟，有效范围5~43200</span>
			    </div>
			   
		   </div>
		   <div class="form-group">
				<label class="col-sm-4 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pt10px pr10px">
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		    
		</form>
   </div>	
</template>
<script>
	export default {
		name: "InsGT740GSMOpenSet",
		data() {
			return {
				uploadInterval:"",         //上传间隔
				timeD1:"",                 //上报模式
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.uploadInterval = ''
				this.timeD1 = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				if(/^\d+$/.test(this.uploadInterval)){
					if(this.uploadInterval>=10 && this.uploadInterval<=1800){
						this.alertMsg = ''
					}
					else{
						this.alertMsg = '请填写正确有效范围'
						return
					}
				}else{
					this.alertMsg = '请输入有效数字'
					return
				}
				if(/^\d+$/.test(this.timeD1)){
					if(this.timeD1>=5 && this.timeD1<=43200){
						this.alertMsg = ''
					}else{
						this.alertMsg = '请填写正确有效范围'
						return
					}
				}else{
					this.alertMsg = '请输入有效数字'
					return
				}
				
				let arr = ["SETPRM","MODE",1,this.uploadInterval,this.timeD1]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsGT740GSMOpenSet.vue?483bb98b